import React from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
}
export function Select({
  label,
  error,
  options,
  className = '',
  ...props
}: SelectProps) {
  return <div className="w-full" data-id="element-140">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-141">
          {label}
        </label>}
      <select className={`block w-full rounded-md border-gray-300 border py-2 px-3 focus:border-bulog-blue focus:ring-bulog-blue sm:text-sm ${error ? 'border-red-300' : ''} ${className}`} {...props} data-id="element-142">
        {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-143">
            {opt.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-144">{error}</p>}
    </div>;
}